import { render } from "./ProposalArgumentsList.vue?vue&type=template&id=73e5b8ce"
import script from "./ProposalArgumentsList.vue?vue&type=script&lang=js"
export * from "./ProposalArgumentsList.vue?vue&type=script&lang=js"

import "./ProposalArgumentsList.vue?vue&type=style&index=0&id=73e5b8ce&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__